import React, { useRef, useState, useEffect } from "react";
import { Stack, IconButton, Text } from "@primer/react";
import { DownloadIcon, TrashIcon, XIcon } from "@primer/octicons-react";
import { useAlert } from "../../context/alert";

interface FileListUploadedComponentProps {
  file: File;
  onFileDidDeleted: () => void;
  isUploading?: boolean;
  progress?: number;
  onCancel?: () => void;
}

const FileListUploadedComponent = ({
  file,
  onFileDidDeleted,
  isUploading = false,
  progress = 0,
  onCancel,
}: FileListUploadedComponentProps) => {
  const { setError } = useAlert();

  const downloadFile = () => {
    try {
      const url = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      setError("Ошибка при скачивании файла");
    }
  };


  const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) {
      return `${bytes} Б`;
    } else if (bytes < 1024 * 1024) {
      return `${Math.round(bytes / 1024)} КБ`;
    } else {
      return `${Math.round(bytes / (1024 * 1024))} МБ`;
    }
  };

  return (
    <Stack direction="vertical" gap="none" className="w-full rounded-lg border border-border">
      <Stack direction="horizontal" gap="normal" justify="space-between" className="w-full">
        <Stack gap="none" className="ml-4 mt-2 mb-2">
          <Text
            as="span"
            weight="normal"
            className="text-[15px] text-aloix-black"
          >
            {file.name}
          </Text>
          <Text
            as="span"
            weight="normal"
            className="text-[12px] text-aloix-grey"
          >
            {formatFileSize(file.size)}
          </Text>
        </Stack>
        <div></div>
        <Stack direction="horizontal" gap="normal" justify="start" className="mt-2 mb-2 ml-2 mr-2">
          {!isUploading && (
            <IconButton
              icon={DownloadIcon}
              aria-label="Скачать"
              onClick={downloadFile}
            >
              Скачать
            </IconButton>
          )}

          {isUploading ? (
            <IconButton
              variant="invisible"
              icon={XIcon}
              aria-label="Отменить"
              onClick={onCancel}
            >
              Отменить
            </IconButton>
          ) : (
            <IconButton
              variant="danger"
              icon={TrashIcon}
              aria-label="Удалить"
              onClick={onFileDidDeleted}
            >
              Удалить
            </IconButton>
          )}
        </Stack>
      </Stack>

      {isUploading && (
        <div className="px-4 py-3 mb-3">
          <div className="w-full bg-[#D1D9E0] rounded-full h-2">
            <div
              className="bg-[#1A7F37] h-2 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      )}
    </Stack>
  );
};

export default FileListUploadedComponent;